import { render } from "./MachineMeasurementsHistoryTable.vue?vue&type=template&id=39b2ac46"
import script from "./MachineMeasurementsHistoryTable.vue?vue&type=script&lang=js"
export * from "./MachineMeasurementsHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__